<div class="content-insights" (scroll)="onScroll($event)">
  <div *ngIf="insightsLists.length" class="content-slide-list-insights">
    <div class="grid">
      <div *ngFor="let list of insightsLists" (click)="clickOnList.emit(list.id)" class="grid__s-4">
        <div class="wrapper-list-insights">
          <div class="image-insights">
            <img [src]="list?.lyst_image_url !== null ? list?.lyst_image_url  : 'assets/images/no-image.png'" alt="">
          </div>
          <span class="name-list-insights">{{list | matchLocale}}</span>
          <p>{{list.favorite_users_count}} <span> {{'NEW_TEXT.likes' | translate}}</span></p>
          <p>{{list.views_count}} <span> {{'NEW_TEXT.views' | translate}}</span></p>
          <p>{{list.shares_count}} <span>{{'INSIGHTS.shares' | translate}}</span></p>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!insightsLists.length" class="wrapper-no-list-view-insights">
    <img src="./assets/icons/icon-no-list-insights.svg" alt="">
    <span class="label1">
      {{'INSIGHTS.no_lists_available' | translate}}
    </span>
    <span class="label2">{{'INSIGHTS.you_didnt_post_any_lists_during_this_time.' | translate}}</span>
  </div>
</div>
